module.exports = __webpack_public_path__ + "img/已定位_local.87789053.svg";